export { default } from './translate';
export * from './translateRaw';

export const languages: Record<string, string> = {
  en: 'English'
};
